import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'label', 'helper'];

  connect() {
    this.inputTarget.removeEventListener('toggle', this.toggle.bind(this))
    this.inputTarget.addEventListener('focus', this.focus.bind(this))
    this.inputTarget.addEventListener('blur', this.blur.bind(this))

    const hasError = this.inputTarget.dataset.hasError === 'true';
    if (hasError) this.showError();
  }

  disconnect() {
    this.inputTarget.removeEventListener('toggle', this.toggle.bind(this))
    this.inputTarget.removeEventListener('focus', this.focus.bind(this))
    this.inputTarget.removeEventListener('blur', this.blur.bind(this))
  }

  showError() {
    this.inputTarget.classList.add('border-red-300', 'bg-red-100');
    this.inputTarget.classList.add(
      'checked:bg-red-1000',
      'checked:border-red-1000',
      'checked:hover:border-red-1000',
    );

    if (this.hasHelperTarget) {
      this.helperTarget.classList.add('text-red-1000');
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.add('text-red-1000');
    }
  }

  focus() {
    this.inputTarget.classList.add(
      'ring-2',
      'ring-black-100',
      'ring-offset-2',
      'ring-offset-white',
    );
  }

  blur() {
    this.inputTarget.classList.remove(
      'ring-2',
      'ring-black-100',
      'ring-offset-2',
      'ring-offset-white',
    );
  }

  toggle() {
    // e.g., clear error
  }
}
